/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=1ed6f6c9&scoped=true"
import script from "./AppHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=1ed6f6c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed6f6c9",
  null
  
)

export default component.exports